"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { ReactNode, useRef } from "react";

type Props = {
  children: ReactNode[];
};

// Inspiré de www.hover.dev/components/carousels#horizontal-scroll-carousel
export const HorizontalStackedBlocks = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { scrollYProgress } = useScroll({ target: ref });

  const totalBlocks = children.length;
  const end = -(totalBlocks - 1) * 100;
  const x = useTransform(scrollYProgress, [0, 1], ["0vw", `${end}vw`]);

  return (
    <section
      ref={ref}
      className="relative"
      style={{ height: `${totalBlocks * 100}vh` }}
    >
      <div className="sticky top-0 lg:top-14 overflow-hidden">
        <motion.div style={{ x }} className="flex">
          {children.map((child, index) => (
            <div key={index} className="w-screen shrink-0">
              {child}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
